import React, { useContext } from "react";
import { Row, Col, Card } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBan } from "@fortawesome/free-solid-svg-icons";
import { UserContext } from "./UserContext";

const NotAuthorized = () => {
  const { user } = useContext(UserContext);

  return (
    <Row>
      <Col md={4}></Col>
      <Col md={4}>
        <Card className='mb-3 index-card text-center' cypressid='notAuthoriedCard'>
          <Card.Body className='text-center'>
            {" "}
            <FontAwesomeIcon className='font-icon mb-2' icon={faBan} style={{ color: "#147995", fontSize: "500%" }} />
            <br />
            {!user.isPublic ? (
              <span style={{ color: "#5fa7be" }}>
                You are not authorized to view this content. Contact the system administrator if you feel you have
                reached this page in error.
              </span>
            ) : (
              <span style={{ color: "#5fa7be" }}>You must be logged in to view this content.</span>
            )}
          </Card.Body>
        </Card>
      </Col>
      <Col md={4}></Col>
    </Row>
  );
};

export default NotAuthorized;
